import api from './api';
import { Category, CategoryFormData } from '@/types/taxonomy';

export const categoryApi = {
    // Kategorileri listele
    async getCategories(): Promise<Category[]> {
        try {
            const response = await api.get('/admin/taxonomy');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching categories:', error);
            throw new Error(error.response?.data?.error || 'Kategoriler yüklenemedi');
        }
    },

    // Tek kategori getir
    async getCategory(categoryId: string): Promise<Category> {
        try {
            const response = await api.get(`/admin/taxonomy/${categoryId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching category:', error);
            throw new Error(error.response?.data?.error || 'Kategori yüklenemedi');
        }
    },

    // Yeni kategori ekle
    async createCategory(categoryData: CategoryFormData): Promise<Category> {
        try {
            const payload: any = {
                name: categoryData.name,
                slug: categoryData.slug,
                description: categoryData.description,
                order: categoryData.order,
                status: categoryData.status,
            };

            // Optional alanları ekle
            if (categoryData.parentId !== undefined) {
                payload.parentId = categoryData.parentId;
            }
            if (categoryData.image !== undefined) {
                payload.image = categoryData.image;
            }

            const response = await api.post('/admin/taxonomy', payload);
            return response.data;
        } catch (error: any) {
            console.error('Error creating category:', error);
            throw new Error(error.response?.data?.error || 'Kategori oluşturulamadı');
        }
    },

    // Kategori güncelle
    async updateCategory(categoryId: string, categoryData: Partial<CategoryFormData>): Promise<Category> {
        try {
            const payload: any = {};

            if (categoryData.name !== undefined) payload.name = categoryData.name;
            if (categoryData.slug !== undefined) payload.slug = categoryData.slug;
            if (categoryData.description !== undefined) payload.description = categoryData.description;
            if (categoryData.order !== undefined) payload.order = categoryData.order;
            if (categoryData.status !== undefined) payload.status = categoryData.status;
            if (categoryData.parentId !== undefined) payload.parentId = categoryData.parentId;
            if (categoryData.image !== undefined) payload.image = categoryData.image;

            const response = await api.put(`/admin/taxonomy/${categoryId}`, payload);
            return response.data;
        } catch (error: any) {
            console.error('Error updating category:', error);
            throw new Error(error.response?.data?.error || 'Kategori güncellenemedi');
        }
    },

    // Kategori sil
    async deleteCategory(categoryId: string): Promise<void> {
        try {
            await api.delete(`/admin/taxonomy/${categoryId}`);
        } catch (error: any) {
            console.error('Error deleting category:', error);
            throw new Error(error.response?.data?.error || 'Kategori silinemedi');
        }
    },

    // Kategori sırasını değiştir
    async reorderCategory(categoryId: string, direction: 'up' | 'down'): Promise<Category> {
        try {
            const response = await api.put(`/admin/taxonomy/${categoryId}/reorder`, { direction });
            return response.data;
        } catch (error: any) {
            console.error('Error reordering category:', error);
            throw new Error(error.response?.data?.error || 'Kategori sırası değiştirilemedi');
        }
    },

    // Kategori ID'sinden getir
    async getCategoryById(categoryId: string): Promise<Category> {
        try {
            const response = await api.get(`/admin/taxonomy/${categoryId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching category by ID:', error);
            throw new Error(error.response?.data?.error || 'Kategori getirilemedi');
        }
    },
};
